/**
 * JWNET取扱品目
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/items`

const search_item = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * テナントにて設定されたJWNET品目を取得.
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * マスタに登録されたJWNET品目を取得.
     * @param param0
     * @param param0.commit
     * @param recycle_disposer_disposal_method_id { Number } 再資源化 処分場処理方法ID
     * @return {Promise<unknown>}
     */
    fetchWholeItems ({ commit }, recycle_disposer_disposal_method_id = null) {
      const params = {
        whole: true,
        recycle_disposer_disposal_method_id: recycle_disposer_disposal_method_id
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_item
